<template>
  <main
   v-loading="loading">
    <el-row>
      <el-col :span="24" class="result">
        <div v-if="result.brand" id="print">
          <el-row class="blockPrint" :span="12">
            <img src="http://doc.airzone.es/Resources/Images/IMG_EASYZONE_TOOL_DOC_HEADER.jpg" style="width:100%"/>
          </el-row>
            <h3
            v-html="$t(
              'ResultUnid',
              {unid: result.indoor_unit
              , manufacturer: result.brand.name})" />

          <el-row>
            <h4 v-html="$t('ResultYourRefer')" />
          </el-row>

          <el-row>
              <p
              v-for="(compatibility,key) in result.protocol_compatibilities"
              :key="key"
              v-html="compatibility.article_reference"
              class="article" />
          </el-row>

          <el-row v-if="compatibilityType === 'AIDOO'">
            <p v-html="$t('SelectInclude')"/>
            <p
            v-html="$t(`${compatibilityType}.include.protocolo`,{
            article: $t(`${compatibilityType}.articles.${articleType}.title`),
            protocolo: $t(`protocolo.${protocolo}`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
            <ul>
              <li
              class="vList"
              v-for="(list, key) in $t(`${compatibilityType}.include.accesrories`)"
              :key="key"
              v-html="list"/>
            </ul>
          </el-row>

          <el-row v-if="compatibilityType === 'UNO_SYSTEM'">
            <p v-html="$t('SelectInclude')"/>
            <p
            v-html="$t(`${compatibilityType}.include.pack`,{
            type: $t(`${compatibilityType}.articles.${articleType}.type`),
            protocolo: $t(`protocolo.${protocolo}`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
            <ul>
              <li
              class="vList"
              v-html="$t(`${compatibilityType}.include.list1`,{
              type: $t(`${compatibilityType}.articles.${articleType}.type`),
              protocolo: $t(`protocolo.${protocolo}`),
              conection: $t(`${compatibilityType}.articles.${articleType}.conection`)})"/>
              <li
              class="vList"
              v-html="$t(`${compatibilityType}.include.list2`,{
              type: $t(`${compatibilityType}.articles.${articleType}.type`),
              conection: $t(`${compatibilityType}.articles.${articleType}.conection`),
              color: $t(`${compatibilityType}.articles.${articleType}.color`)})"/>
              <li
              v-if="typeConection() === 'C'"
              class="vList"
              v-html="$t(`${compatibilityType}.include.list3`)"/>
              <li
              v-else
              class="vList"
              v-html="$t(`${compatibilityType}.include.list4`)"/>
            </ul>

          </el-row>

          <el-row v-if="compatibilityType === 'MONOZONE'">
            <p v-html="$t('SelectInclude')"/>
            <p
            v-if="protocolo!=='F10'"
            v-html="$t(`${compatibilityType}.include.pack`,{
            name: $t(`${compatibilityType}.articles.${articleType}.title`),
            protocolo: $t(`protocolo.${protocolo}`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
            <p
            v-else
            v-html="$t(`${compatibilityType}.include.pack2`,{
            protocolo: $t(`protocolo.${protocolo}`),
            conection: $t(`${compatibilityType}.articles.${articleType}.conection`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
          </el-row>

          <el-row v-if="compatibilityType === 'ZONIFIED'">
            <p v-html="$t('SelectInclude')"/>
            <p
            v-if="result.protocol_compatibilities[0].article_reference.search('AZX6GTC') > -1"
            v-html="$t(`${compatibilityType}.include.pack2`,{
            name: $t(`${compatibilityType}.articles.${articleType}.title`),
            protocolo: $t(`protocolo.${protocolo}`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
            <p
            v-else
            v-html="$t(`${compatibilityType}.include.pack1`,{
            name: $t(`${compatibilityType}.articles.${articleType}.title`),
            protocolo: $t(`protocolo.${protocolo}`),
            url: createLinkText(result.protocol_compatibilities[0].article_reference),
            product: result.protocol_compatibilities[0].article_reference})"/>
          </el-row>

          <el-row>
            <p v-html="$t(`${compatibilityType}.articles.${articleType}.descResult`)"/>
            <div
            v-if="articleType === 'AIDOO_WIFI'"
            style="text-align:center">
              <img
              v-for="(image, key) in $t(`${compatibilityType}.articles.${articleType}.logos`)"
              :key="key"
              :src="image"
              style="width:35%" />
            </div>
          </el-row>

          <el-row v-if="result.warnings">
            <el-col :span="24">
              <p
              class="alert"
              v-for="(warning,key) in result.warnings"
              :key="key"
              v-html="warning.description"/>
            </el-col>
          </el-row>
          <el-row v-if="result.protocol_compatibilities && result.protocol_compatibilities[0].warnings">
            <el-col :span="24">
              <p
              class="alert"
              v-for="(warning,key) in result.protocol_compatibilities[0].warnings"
              :key="key"
              v-html="warning.description"/>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </main>
</template>

<script>
import CompatibilityServices from '@/api/CompatibilityServices';
import LoaderMixin from '@/mixins/Loader.mixin';

export default {
  name: 'Result',
  mixins: [LoaderMixin],
  props: {
    appMarket: {
      type: String,
      default: '',
    },
    appLocale: {
      type: String,
      default: '',
    },
    compatibilityType: {
      type: String,
      default: '',
    },
    articleType: {
      type: String,
      default: '',
    },
    brand: {
      type: Number,
      default: 0,
    },
    iumodel: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      result: {},
      protocolo: ''
    };
  },
  methods: {
    async getApi() {
      const requestHeaders = {
        headers: {
          'app-market': this.appMarket,
          'app-locale': this.appLocale,
          apiKey: process.env.VUE_APP_APIKEY,
        },
      };
      const response = await CompatibilityServices
        .getResult(requestHeaders, this.compatibilityType, this.articleType, this.brand, this.iumodel);
      this.result = response.data.body.iumodel;
      this.protocolo = this.result.protocol_compatibilities[0].iumodel_compatibility_iso;
    },
    createLinkText(codeSearch) {
      const search = codeSearch;
      const url = `${window.location.origin}/s/${search}`;
      if (localStorage.getItem('app')) {
        return `${codeSearch}`;
      }
      return url;
    },
    typeConection() {
      const text = this.result.protocol_compatibilities[0].article_reference;
      console.log(text[text.length - 2]);
      return text[text.length - 2];
    }
  },
  mounted() {
    this.getApi();
  },
};
</script>

<style scoped lang="scss">
  .blockPrint{
    display: none;
  }
  .result {
    text-align: left
  }
.article {
  font-size: 20px;
  font-weight: bold;
}
  .alert{
    font-size: 15px;
    margin: 10px 0px 10px 0px;
    background-color: #fdf6ec;
    border: 1px solid #faecd8;
    border-radius: 5px;
    padding: 5px;
    color:#e6a23c;
  }
  .vList{
    list-style: circle;
  }

</style>
